import { PlanPicker } from "@/components/meal-plan/plan-picker";
import { PresetEditor } from "@/components/meal-plan/preset-editor";

export function RegimenPage() {
  return (
    <div className="w-full mx-auto max-w-3xl px-4 py-6 flex-1 overflow-y-auto space-y-4">
      <PlanPicker />
      <PresetEditor />
    </div>
  );
}
